import { http } from "./http";
import qs from "qs";
import { BASIC_AUTH_HEADER } from "./yandex";
import { AuthService } from "../services/auth";

export const getCode = async (state, redirectUrl, clientId) => {
  return await http.get(
    `/oauth/authorize?response_type=code&client_id=${clientId}&redirect_uri=${redirectUrl}&state=${state}`,
    {
      headers: {
        Authorization: `Bearer ${AuthService.Details.access_token}`
      }
    }
  );
};

export const signUp = async user => {
  return await http.post("/users", user);
};

export const signIn = async user => {
  return await http.post("/oauth/token", qs.stringify(user), {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: BASIC_AUTH_HEADER
    }
  });
};

export const forgot = async data => {
  return await http.post("/user/forgot", data);
};

export const confirmUser = async id => {
  return await http.post("/user/confirm", { id });
};
